import React from 'react';
import SceButton from "../../../../Common/CommonComponents/sceButton";
import ServiceAccountDetailsComponent from './serviceAccountDetailsComponent';
import overlayClasses from "./sceOverlayStyle.scss";
import classes from './outageTurnOffPopup.scss';
import { getLocalizedStrings } from "../../../centralizedLocalizedString";
import OutageErrCard from "../Common/outageErrCard";
import FocusTrap from "focus-trap-react";
class OutageTurnOffPopup extends React.Component {

    constructor(props) {
        super(props);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this); 
        this.strings = getLocalizedStrings("RepairMaintenanceAlerts");
        this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
           }
        componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
         }
    
        componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
            }
        
        setWrapperRef(node) {
            this.wrapperRef = node;
          }
        
        handleClickOutside(event) {
            if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.props.handleClose();
            //  alert("clicked");
        
            }
          } 


    render() {
       
        let serviceAccountDetailsJSX;
         serviceAccountDetailsJSX = <ServiceAccountDetailsComponent selectedAccount={this.props.selectedAccount} />;
        return (
            <FocusTrap 
            focusTrapOptions={{
               allowOutsideClick: true,
           }}
           >
            <div>
                <div tabIndex="0" className={[overlayClasses.sceOverlay, classes.sceSetNotificationsDialog].join(' ')}>
                    <div className={overlayClasses.sceOverlayContent}>
                        <div   ref={this.setWrapperRef} className={overlayClasses.sceDialogBox}>
                        <div className={classes.textAlignLeft}>
                            <div className='row'>

                                <div className={'col-xs-12 ' + classes.sceSetNotificationMainHeader}>{this.strings.turnOffHeader} <button className={classes.iconClose}  onClick={this.props.handleClose} > <img  src={this.closeIcon} alt="close Icon" /></button></div>
                                {(this.props.isErrorCard) ? 
                                 <div>
                                 <OutageErrCard
                                  onFormhandler={this.props.outageDeEnrollClick}
                                 />
                               </div>
                               : null}

                                <div className={'col-xs-12 ' + classes.sceSetNotificationHeader}>{this.strings.turnoffDescription}</div>

                            </div>
                            {serviceAccountDetailsJSX}


                            <div className="text-align-center">
                                <div className={classes.footerButton}>
                                    <div className={classes.turnOnBtn}>
                                        <SceButton
                                            id="OutageAlertsTurnOff"
                                            iconType="rightArrow"
                                            buttonType="primary"
                                            value={this.strings.turnOffBtn}
                                            onClick={this.props.outageDeEnrollClick}
                                       />
                                    </div>
                                    <div className={classes.cancelBtn}>
                                    <SceButton

                                        id="turnOffOutageCancel"
                                        iconType="cancel"
                                        buttonType="sceCancel"
                                        value={this.strings.cancelButton}
                                        onClick={this.props.handleClose}
                                    />
                                </div>
                                </div>                                
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            </FocusTrap>
        );
    }
}
export default OutageTurnOffPopup;
